import { ProtoData } from "../../../root/index.ts";
import NDropzoneController from "./NDropzoneController.ts";

export class NDropzoneData extends ProtoData
{
    /**
     * @type {NDropzoneController}
     */
    declare scope : NDropzoneController;

    get classList() : string[]
    {
        return this.classRoot([]);
    }

    get item() : any
    {
        return this.scope.get('item');
    }

    get mode() : string
    {
        return this.scope.get('mode');
    }

    get allowGroups() : string[]
    {
        return this.scope.get('allowGroups');
    }

    get allowDrop() : any
    {
        return this.scope.get('allowDrop');
    }

}

export default NDropzoneData;